import slick from 'slick-carousel';


export const slider = () => {
    if($('.slider .slider-items').length > 0) {
        $('.slider .slider-items').slick({
            infinite: true,
            slidesToShow: 1,
            fade: true,
            slidesToScroll: 1,
            dots: true,
            speed: 300,
            arrows: true,
            adaptiveHeight: true,
            prevArrow: $('.slider-arrow.prev'),
            nextArrow: $('.slider-arrow.next')
        });
    }
}

export const sliderOnlyMobile = () => {
    const sliderBox = $('.slider-only-mobile .slider-items');

    if(window.innerWidth < 768) {
        mobileSlider();
    }
    
    $(window).resize(function(e){
        if(window.innerWidth < 768) {
            if(!sliderBox.hasClass('slick-initialized')){
                mobileSlider();
            }
        }else{
            if(sliderBox.hasClass('slick-initialized')){
                sliderBox.slick('unslick');
            }
        }
    });
    
    function mobileSlider() {
        $('.slider-only-mobile .slider-items').slick({
            infinite: true,
            slidesToShow: 1,
            fade: true,
            slidesToScroll: 1,
            dots: true,
            speed: 300,
            arrows: true,
            adaptiveHeight: true,
            prevArrow: $('.slider-arrow.prev'),
            nextArrow: $('.slider-arrow.next')
        });
    }
}
